const NairaSign = () => {
  return <span>&#x20A6;</span>;
};

export default NairaSign;
